import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../../../translations';

type ReceptionServicePractitionerRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly shouldShowModal?: boolean;
   readonly practitionerName: string;
   readonly receptionServiceName?: string;
};

export const ReceptionServicePractitionerRemoveConfirmationEventInterceptor = (
   props: ReceptionServicePractitionerRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   const { confirmation } = receptionServiceTranslationKeys.table.remove.practitioner;

   return (
      <ShowModalEventInterceptor
         shouldShowModal={Boolean(props.shouldShowModal)}
         modalWidth={ModalWidth.NORMAL}
         testId={'practitionerReceptionServiceRemoveConfirmation'}
         title={confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={confirmation.content.manyPractitioners}
               components={{ bold: <strong /> }}
               values={{
                  receptionServiceName: props.receptionServiceName,
                  practitionerName: props.practitionerName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
